import React, { useState, useEffect } from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import { Box } from '@mui/material';
import DataBox from '../../../general/data/DataBox';
import DataRow from '../../../general/data/DataRow';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import TodayIcon from '@mui/icons-material/Today';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventNoteIcon from '@mui/icons-material/EventNote';
import { getDoctorFinancials } from '../../../../routes/hacker/users';

const DoctorFinancials: React.FC = () => {
    const colors = useAppSelector(state => state.theme.colors); 
    const selectedDoctor = useAppSelector(state => state.doctorsAccess.selectedDoctor); 
    const [financials, setFinancials] = useState<any>(null); 

    useEffect(() => { 
        const fetchFinancials = async () => {
            if (selectedDoctor) { 
                const res = await getDoctorFinancials(selectedDoctor._id);
                if (res?.data?.status === 200) { 
                    setFinancials(res.data.financials); 
                }
            }
        };
        fetchFinancials();
    }, [selectedDoctor]); 

    if (!financials) {
        return null; // Or a loading spinner
    }

    return (
        <DataBox title='Financials (Cost-to-Serve)'>
            <DataRow 
                icon={<TodayIcon sx={{ color: colors?.main }} />} 
                title={'This Month'} 
                data={`$${financials.monthly.cost} (${financials.monthly.notes} notes)`} 
            />
            <DataRow 
                icon={<CalendarMonthIcon sx={{ color: 'rgb(146, 86, 29)' }} />} 
                title={'Year-to-Date'} 
                data={`$${financials.ytd.cost} (${financials.ytd.notes} notes)`} 
            />
            <DataRow 
                icon={<EventNoteIcon sx={{ color: 'rgb(99, 58, 21)' }} />} 
                title={'All-Time'} 
                data={`$${financials.allTime.cost} (${financials.allTime.notes} notes)`} 
            />
        </DataBox> 
    );
};

export default DoctorFinancials;